import { GlTooltip, GlIcon, GlLink, GlTruncate } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'WorkItemAttribute',
    components: {
        GlTooltip,
        GlIcon,
        GlLink,
        GlTruncate
    },
    props: {
        anchorId: {
            type: String,
            required: false,
            default: ''
        },
        wrapperComponent: {
            type: String,
            required: false,
            default: 'span'
        },
        wrapperComponentClass: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        titleComponentClass: {
            type: String,
            required: false,
            default: ''
        },
        iconName: {
            type: String,
            required: false,
            default: ''
        },
        iconClass: {
            type: String,
            required: false,
            default: ''
        },
        iconSize: {
            type: Number,
            required: false,
            default: 16
        },
        tooltipText: {
            type: String,
            required: false,
            default: ''
        },
        tooltipPlacement: {
            type: String,
            required: false,
            default: 'bottom'
        },
        isLink: {
            type: Boolean,
            required: false,
            default: false
        },
        href: {
            type: String,
            required: false,
            default: undefined
        },
        ariaLabel: {
            type: String,
            required: false,
            default: undefined
        },
        popoverAttributes: {
            type: Object,
            required: false,
            default: null
        },
        srOnlyText: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'click'
    ],
    computed: {
        tooltipTarget () {
            return ()=>{
                const ref = this.$refs.wrapperRef;
                return ref?.$el || ref;
            };
        },
        hasPopover () {
            return this.popoverAttributes !== null;
        }
    },
    methods: {
        handleClick (event) {
            this.$emit('click', event);
            if (this.isLink && this.href) {
                event.stopPropagation();
            }
        }
    }
};
